<div class="search-bar" role="search">
  <div class="search-txt" translate="common_search"></div>
  <input #textInput
    type="text"
    class="form-control search-input"
    attr.aria-label="{{'common_search'| translate}}"
    [(ngModel)]="searchText"
    (ngModelChange)="onSearchQueryUpdate($event)"/>
  <div class="action-wrapper">
    @if (!searchText) {
      <span mat-icon><i class="ficon-search"></i></span>
    }
    @if (searchText) {
      <button type="button" class="ficon-app-x clear-btn icon-btn" (click)="clearText()"></button>
    }
  </div>
</div>
